module.exports = __webpack_public_path__ + "img/bao_boller.8e080ac2.jpg";